import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { BiMap } from 'react-icons/bi';
import { v4 as uuidv4 } from 'uuid';

const WidgetGetinTouchData = [{
        id: uuidv4(),
        icon: < AiOutlinePhone / > ,
        heading: 'Phone Number',
        text: '+91 9842092187',
    },

    {
        id: uuidv4(),
        icon: < AiOutlinePhone / > ,
        heading: 'Phone Number',
        text: '+91 8015264213',
    }
];

export default WidgetGetinTouchData;